import React, { useRef, useState, useEffect } from 'react';
import { Container, Row, Col, Card, Image } from 'react-bootstrap';
import playButton from "@assets/images/icons/icons8-circled-play-32.png"
import pauseButton from "@assets/images/icons/icons8-pause-button-color-32.png"
import "./AudioPlayer.css"
//import ProgressBar  from "@apps/common/components/ProgressBar"

function AudioPlayer({ src, title, onPlaybackUpdate, onPlaybackEnded, startTime }:
    { src: string, title: string, onPlaybackUpdate: (currentPlaybackTime: number) => void, onPlaybackEnded: () => void, startTime: number }) {
    const audioRef = useRef<HTMLAudioElement>(null);

    //const progressBarRef = useRef<HTMLObjectElement>(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [progress, setProgress] = useState(0);
    const [intervalId, setIntervalId] = useState<number>()

    const togglePlay = () => {
        if (isPlaying) {

            audioRef?.current?.pause();
        } else {
            audioRef?.current?.play();
        }
        setIsPlaying(!isPlaying);
    };
    useEffect(() => {
        if (audioRef?.current) {
            //console.debug(`Move forward - ${startTime}`)
            audioRef.current.currentTime = startTime
        }

        togglePlay()
    }, [])

    useEffect(() => {
        const audio = audioRef.current;
        if (audio) {
            audio.addEventListener('timeupdate', handleTimeUpdate);
            return () => {
                audio.removeEventListener('timeupdate', handleTimeUpdate);
            };
        }
    }, [audioRef]);

    const handleTimeUpdate = () => {

        const audio = audioRef.current;
        if (audio) {
            setProgress((audio.currentTime / audio.duration) * 100);
        }
    };

    const handleProgressChange = (event: any) => {
        const audio = audioRef.current;
        if (audio) {
            const newTime = (event.target.value / 100) * audio.duration;
            audio.currentTime = newTime;
            setProgress(event.target.value)
        }
    };

    const saveAudioProgress = () => {
        if ((audioRef.current?.currentTime) && (onPlaybackUpdate !== null))
            onPlaybackUpdate(audioRef.current?.currentTime)
    }

    return (
        <Container fluid={true} className="align-items-left">
            {/* <Card className="rounded-4" style={{background:'#ebeadf'}}>
                <Card.Body> */}
            <Row fluid={true} className="align-items-left">
                {/* <Col xs={12} md={1}> */}
                {/* <Image
                        src={isPlaying ? pauseButton : playButton}
                        onClick={togglePlay}
                        style={{ height: 'auto', maxWidth: '100%' }} // Ensure image responsiveness
                    /> */}
                {/* </Button> */}
                {/* </Col> */}
                <Col>
                    <Card.Title className="text-start">{title}</Card.Title>
                </Col>
            </Row>
            {/* <Row>
                <Col>
                    <input
                        type="range"
                        min="0"
                        max="100"
                        value={progress}
                        onChange={handleProgressChange}
                        style={{
                            'appearance': 'auto',
                            'opacity': 0.7,
                            height: '5px',
                            background: '#345beb',
                            borderRadius: '1px',
                            cursor: 'pointer',

                            width: '100%'
                        }}
                    />          
                </Col>
            </Row> */}
            <Row>
                <audio
                    src={src}
                    ref={audioRef}
                    onTimeUpdate={handleTimeUpdate}
                    onEnded={() => {
                        setIsPlaying(false);
                        onPlaybackEnded();
                        clearInterval(intervalId)
                    }}
                    onPlay={() => {

                        const id = setInterval(
                            function () {
                                (saveAudioProgress());
                            },
                            15000 // every 15 seconds
                        );
                        setIntervalId(id)
                    }}
                    controls
                    controlsList="nodownload"

                />
            </Row>

            {/* </Card.Body>
            </Card> */}
        </Container>
    );
}

export default AudioPlayer;

